import '.am{flex-shrink:0;}.ssr-plugin'
import '.ao{padding:1rem;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.an{height:100%;}.ssr-plugin'
import '.aq{border:none;}.ssr-plugin'
import '.ar{background-color:transparent;}.ssr-plugin'
import '.gj{border-radius:0px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a2{align-items:stretch;}.ssr-plugin'
import '.b2{position:sticky;}.ssr-plugin'
import '.gk{top:4rem;}.ssr-plugin'
import '.gl{z-index:7;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.gm{padding-bottom:1rem;}.ssr-plugin'
import '.cv{margin-bottom:1rem;}.ssr-plugin'
import '.gn{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.i{position:fixed;}.ssr-plugin'
import '.b3{top:0px;}.ssr-plugin'
import '.ba{left:0px;}.ssr-plugin'
import '.bb{right:0px;}.ssr-plugin'
import '.bc{bottom:0px;}.ssr-plugin'
import '.cl{z-index:9999;}.ssr-plugin'
import '.cm{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.b0{justify-content:flex-end;}.ssr-plugin'
import '.ap{flex:1;}.ssr-plugin'
import '.bm{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="am ao l an aq ar gj"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="d e a2"
    >
      <div className="b2 gk gl t gm cv gn d"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="i b3 ba bb bc cl t cm d e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="ao d b0 gn"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="ap bm">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
